import { IconButton } from './StandardButtons';

/**
 * DetailViewActionButtons - Reusable action buttons for detail views
 * Displays a row of action buttons (copy, delete, etc.) at the top right of detail views
 */
export default function DetailViewActionButtons({ actions = [] }) {
  if (!actions || actions.length === 0) {
    return null;
  }

  return (
    <div className="flex gap-2">
      {actions.map((action, index) => {
        // Skip rendering if action is conditionally hidden
        if (action.hidden) {
          return null;
        }

        return (
          <IconButton
            key={action.id || index}
            onClick={action.onClick}
            title={action.tooltip}
            disabled={action.disabled}
          >
            {action.customIcon ? (
              action.customIcon
            ) : (
              <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={action.icon} />
              </svg>
            )}
          </IconButton>
        );
      })}
    </div>
  );
}
